<template>
	<Page :info="info"/>
</template>
<script>
import Page from '../common/Page'
export default {
	components:{Page},
	data(){
		return {
			info:{
				banner:{
					img:'/static/images/scheme/banner12.jpg',
					title:'大健康风险解决方案',
					subtitle:'我们针对于大健康行业情况，输出定制如下组合方案， <br>供相关企业基于自身需求进行投保'
				},
				product:[15,16,17,5],
				case:[12,13,14]
			}
		}
	},
}
</script>


// WEBPACK FOOTER //
// src/pages/scheme/components/page/Health.vue